import { render, staticRenderFns } from "./DepartmentTeamLayout.vue?vue&type=template&id=0d85ff62&scoped=true"
import script from "./DepartmentTeamLayout.vue?vue&type=script&lang=js"
export * from "./DepartmentTeamLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85ff62",
  null
  
)

export default component.exports